@if (topics().length > 0) {
  <section class="support-topics-section">
    <div class="support-topics-content">
      @if (showHeader()) {
        <div class="support-topics-header">
          @if (headerText() !== null) {
            @if (headerText()) {
              <h2 class="support-topics-title">{{ headerText() }}</h2>
            }
          } @else {
            <h2 class="support-topics-title">{{ title() | translateLang }}</h2>
          }
          @if (subtextText() !== null) {
            @if (subtextText()) {
              <p class="support-topics-description">{{ subtextText() }}</p>
            }
          } @else {
            <p class="support-topics-description">{{ description() | translateLang }}</p>
          }
        </div>
      }

      <div class="support-topics-layout">
        <nav class="support-topics-sidebar" aria-label="Support topics">
          <h3 class="support-topics-sidebar-title">{{ sidebarTitle() | translateLang }}</h3>
          @for (topic of topics(); track topic.id) {
            <button
              type="button"
              class="topic-btn"
              [class.active]="isActiveTopic(topic.id)"
              [attr.aria-current]="isActiveTopic(topic.id)"
              (click)="selectTopic(topic.id)"
            >
              <span>{{ topic.labelKey | translateLang }}</span>
              <span class="topic-btn-count">{{ topic.faqs.length }}</span>
            </button>
          }
        </nav>

        <div class="support-topics-faq-list" role="region" aria-live="polite">
          @if (activeTopic(); as topic) {
            @for (faq of topic.faqs; track faq.questionKey; let i = $index) {
              <div class="faq-item" [class.expanded]="expandedFaqIndex() === i">
                <button
                  type="button"
                  class="faq-question-btn"
                  (click)="toggleFaq(i)"
                  [attr.aria-expanded]="expandedFaqIndex() === i"
                  [attr.aria-controls]="'support-faq-' + i"
                >
                  <span class="faq-question-main">
                    <span class="faq-index">{{ i + 1 }}</span>
                    <span class="faq-question-text">
                      <span class="faq-title">{{ faq.questionKey | translateLang }}</span>
                    </span>
                  </span>
                  <img
                    class="faq-chevron"
                    [src]="
                      expandedFaqIndex() === i
                        ? '/assets/images/icons/faq-chevron-up.svg'
                        : '/assets/images/icons/faq-chevron-down.svg'
                    "
                    width="24"
                    height="24"
                    alt=""
                  />
                </button>
                @if (expandedFaqIndex() === i) {
                  <div [id]="'support-faq-' + i" class="faq-answer">
                    <p>{{ faq.answerKey | translateLang }}</p>
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>

      <!-- ===== Mobile-only Support Topics sidebar (<=480px, phones only) ===== -->
      <!-- Replaces the layout above: no inline FAQ list on mobile — tapping a
         topic opens its FAQ accordion in a bottom sheet instead. -->
      <div class="support-topics-mobile-sidebar">
        <h3 class="support-topics-mobile-sidebar-title">{{ sidebarTitle() | translateLang }}</h3>
        <div class="support-topics-mobile-sidebar-list">
          @for (topic of topics(); track topic.id) {
            <button type="button" class="support-topics-mobile-row" (click)="openMobileFaq(topic)">
              <span class="support-topics-mobile-row-name">{{
                topic.labelKey | translateLang
              }}</span>
              <span class="support-topics-mobile-row-count">{{ topic.faqs.length }}</span>
            </button>
          }
        </div>
      </div>
    </div>
  </section>
}
